import React from 'react';

const MarketPulseHeroWave: React.FC = () => (
  <div className="mp-hero-wave" aria-hidden="true">
    <svg
      className="mp-hero-wave__svg"
      viewBox="0 0 1440 320"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="mp-wave-gradient-primary" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#CBFF00" stopOpacity="0.55" />
          <stop offset="50%" stopColor="#00ED26" stopOpacity="0.35" />
          <stop offset="100%" stopColor="#00ED26" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="mp-wave-gradient-secondary" x1="100%" y1="0%" x2="0%" y2="0%">
          <stop offset="0%" stopColor="#CBFF00" stopOpacity="0.25" />
          <stop offset="60%" stopColor="#00ED26" stopOpacity="0.12" />
          <stop offset="100%" stopColor="#00ED26" stopOpacity="0" />
        </linearGradient>
        <filter id="mp-wave-glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="18" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <path
        className="mp-hero-wave__path mp-hero-wave__path--glow"
        d="M0,220 C240,120 480,280 720,200 C960,120 1200,260 1440,180 L1440,320 L0,320 Z"
        fill="url(#mp-wave-gradient-primary)"
        filter="url(#mp-wave-glow)"
      />
      <path
        className="mp-hero-wave__path mp-hero-wave__path--secondary"
        d="M0,260 C360,180 540,300 900,220 C1080,170 1260,280 1440,240 L1440,320 L0,320 Z"
        fill="url(#mp-wave-gradient-secondary)"
      />
      <path
        className="mp-hero-wave__path mp-hero-wave__path--accent"
        d="M0,290 C200,250 400,310 640,270 C880,230 1120,300 1440,260 L1440,320 L0,320 Z"
        fill="url(#mp-wave-gradient-primary)"
        opacity="0.4"
      />
    </svg>
  </div>
);

export default MarketPulseHeroWave;
